// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","869":"848fc247","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"6a0842261a2e62517711","869":"59c8758ecc1ba4b66d1c","883":"32469a7bccac0f96a68a"}[chunkId] + ".js";
};